import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  Lightbulb,
  Plus,
  FileText,
  List,
} from "lucide-react";
import { CampaignRecommendations } from "./campaign/CampaignRecommendations";
import { CampaignCreate } from "./campaign/CampaignCreate";
import { CampaignReport } from "./campaign/CampaignReport";
import { CampaignAllCampaigns } from "./campaign/CampaignAllCampaigns";

export default function Campaign() {
  const [activeTab, setActiveTab] = useState<string>("recommendations");

  const campaignTabs = [
    {
      id: "recommendations",
      name: "Recommendations",
      icon: Lightbulb,
    },
    {
      id: "all-campaigns",
      name: "All Campaigns",
      icon: List,
    },
    {
      id: "create",
      name: "Create Campaign",
      icon: Plus,
    },
    {
      id: "report",
      name: "Report",
      icon: FileText,
    },
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Campaign</h1>
          <p className="text-muted-foreground">
            Manage and track all your campaign activities
          </p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-4">
          {campaignTabs.map((tab) => (
            <TabsTrigger key={tab.id} value={tab.id} className="text-sm">
              <tab.icon className="h-4 w-4 mr-2" />
              {tab.name}
            </TabsTrigger>
          ))}
        </TabsList>

        <TabsContent value="recommendations" className="space-y-6">
          <CampaignRecommendations />
        </TabsContent>

        <TabsContent value="all-campaigns" className="space-y-6 mt-6">
          <CampaignAllCampaigns />
        </TabsContent>

        <TabsContent value="create" className="space-y-6 mt-6">
          <CampaignCreate />
        </TabsContent>

        <TabsContent value="report" className="space-y-6 mt-6">
          <CampaignReport />
        </TabsContent>
      </Tabs>
    </div>
  );
}
